var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSvgform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#FF5E15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9695 25.4316C47.243 25.2266 47.6531 25.4316 47.6531 25.7734V39.7188C47.6531 41.5645 46.1492 43 44.3719 43H15.9344C14.0887 43 12.6531 41.5645 12.6531 39.7188V25.7734C12.6531 25.4316 12.9949 25.2266 13.2684 25.4316C14.8406 26.6621 16.823 28.166 23.7957 33.2246C25.2313 34.25 27.6922 36.5059 30.1531 36.5059C32.5457 36.5059 35.075 34.25 36.4422 33.2246C43.4148 28.166 45.3973 26.6621 46.9695 25.4316ZM30.1531 34.25C28.5125 34.3184 26.2566 32.2676 25.0945 31.4473C16.0027 24.8848 15.3191 24.2695 13.2684 22.6289C12.8582 22.3555 12.6531 21.877 12.6531 21.3301V20.0312C12.6531 18.2539 14.0887 16.75 15.9344 16.75H44.3719C46.1492 16.75 47.6531 18.2539 47.6531 20.0312V21.3301C47.6531 21.877 47.3797 22.3555 46.9695 22.6289C44.9188 24.2695 44.2352 24.8848 35.1434 31.4473C33.9813 32.2676 31.7254 34.3184 30.1531 34.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSvgform);
export default __webpack_public_path__ + "static/media/email_svgform.ff6d056f38e30ec857511d0cd91dc909.svg";
export { ForwardRef as ReactComponent };